"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _AudioCreativeLayer2 = _interopRequireDefault(require("./AudioCreativeLayer"));

var _isNotNil = _interopRequireDefault(require("../../utils/object/isNotNil"));

var _isNotEmpty = _interopRequireDefault(require("../../utils/array/isNotEmpty"));

var _media = require("../../constants/media");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var VideoCreativeLayer = /*#__PURE__*/function (_AudioCreativeLayer) {
  (0, _inherits2["default"])(VideoCreativeLayer, _AudioCreativeLayer);

  var _super = _createSuper(VideoCreativeLayer);

  function VideoCreativeLayer(element, content, media) {
    var _this;

    (0, _classCallCheck2["default"])(this, VideoCreativeLayer);
    _this = _super.call(this, element, content, media);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_processors", new Set());

    if ((0, _isNotNil["default"])(media) && (0, _isNotEmpty["default"])(media.processors)) {
      _this._processors = new Set(media.processors);
    }

    return _this;
  }

  (0, _createClass2["default"])(VideoCreativeLayer, [{
    key: "addProcessor",
    value: function addProcessor(value) {
      if (_media.VALID_MEDIA_PROCESSORS.has(value)) {
        this._processors.add(value);
      }
    }
    /**
     * Checks if object is an instance of VideoCreativeLayer
     *
     * @param inputObject
     * @returns {boolean}
     */

  }, {
    key: "audioURL",
    get: function get() {
      return this._audioURL;
    },
    set: function set(value) {
      this._audioURL = value;
    }
  }, {
    key: "processors",
    get: function get() {
      return this._processors;
    },
    set: function set(value) {
      this._processors = value;
    }
  }], [{
    key: "isVideoCreativeLayer",
    value: function isVideoCreativeLayer(inputObject) {
      return inputObject instanceof VideoCreativeLayer;
    }
  }]);
  return VideoCreativeLayer;
}(_AudioCreativeLayer2["default"]);

exports["default"] = VideoCreativeLayer;